import { render, staticRenderFns } from "./myecharts.vue?vue&type=template&id=a0cf15ba&scoped=true"
import script from "./myecharts.vue?vue&type=script&lang=js"
export * from "./myecharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cf15ba",
  null
  
)

export default component.exports